<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
  },
  data() {
    return {
      site: 2,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template>
  <div class="multi-slider">
    <MultiSliderComponent
      titulo=""
      :elementos="1"
      :mostrar-titulo="false"
      :mostrar-bordes="true"
      :ajustar="true"
      :data="[
        {
          desc: null,
          imagen: require('@/assets/img/fweb.jpeg'),
          url: 'https://drive.google.com/drive/folders/130M1zuPvMthCZrhi3aL5jR7o8V7f212I?usp=sharing',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/fweb2.jpeg'),
          url: 'https://drive.google.com/file/d/1rfGnHzdc63Cks5mmCAwL5Lx9U4yQrsss/view?usp=drive_link',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/BANNERWEBSTARTUPRECT.png'),
          url: 'https://www.cancilleria.gob.ar/es/next-argentina-startup-portfolio',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/banner_economia_conocimiento.jpg'),
          url: 'https://produccion.sanjuan.gob.ar/pdf/ANEXO_II_Programa_Fortalecimiento_Economía_del_Conocimiento.pdf',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/apoyarnosEnLaCiencia.jpg'),
          url: 'https://produccion.sanjuan.gob.ar/pdf/Bases y condiciones - Apoyarnos en la Ciencia.pdf',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/banner-capacitacion.png'),
          url: 'https://aprendertrabajaryproducir.gob.ar/',
          target: 'blank_',
        },
      ]"
    />
  </div>

  <div class="multi-slider-mobile">
    <MultiSliderComponent
      titulo=""
      :elementos="1"
      :mostrar-titulo="false"
      :mostrar-bordes="true"
      :ajustar="true"
      :data="[
        {
          desc: null,
          imagen: require('@/assets/img/fmobile.jpeg'),
          url: 'https://drive.google.com/drive/folders/130M1zuPvMthCZrhi3aL5jR7o8V7f212I?usp=sharing',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/fmobile2.jpeg'),
          url: 'https://drive.google.com/file/d/1rfGnHzdc63Cks5mmCAwL5Lx9U4yQrsss/view?usp=drive_link',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/BANNERWEBSTARTUPCUAD.png'),
          url: 'https://www.cancilleria.gob.ar/es/next-argentina-startup-portfolio',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/banner_economia_conocimiento.jpg'),
          url: 'https://produccion.sanjuan.gob.ar/pdf/ANEXO_II_Programa_Fortalecimiento_Economía_del_Conocimiento.pdf',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/apoyarnosEnLaCiencia.jpg'),
          url: 'https://produccion.sanjuan.gob.ar/pdf/Bases y condiciones - Apoyarnos en la Ciencia.pdf',
          target: 'blank_',
        },
        {
          desc: null,
          imagen: require('@/assets/img/banner-capacitacion.png'),
          url: 'https://aprendertrabajaryproducir.gob.ar/',
          target: 'blank_',
        },
      ]"
    />
  </div>

  <ITCGridComponent
    columnas="2"
    :data="[
      {
        desc: null,
        icon: 'ptn-i-documento',
        target: '_self',
        title: 'Consulta de Expedientes',
        url: '?uid=CUMV-VIEW-ExpedientesComponent',
      },
      {
        desc: null,
        icon: 'question_answer',
        target: '_self',
        title: 'Consultas y Solicitudes',
        url: '?uid=CUMV-VIEW-FormComponent',
      },
    ]"
  />

  <!-- <DocumentListComponent
    resultados="5"
    :show-fecha="false"
    titulo="Guía de Trámites"
    :filtros="{ site: this.site }"
  /> -->

  <CardGridComponent
    columnas="5"
    :data="[
      {
        target: '_self',
        title: ' Registro de Empresas CEMOFI',
        links: [
          {
            title: 'Registro de Empresas Industriales de San Juan',
            url: 'https://forms.gle/HkNmDoQtJC8kqnAXA',
          },
          {
            title: 'Resolución 254 MPTel 2025',
            url: 'https://produccion.sanjuan.gob.ar/pdf/Resolucion254MPTeI2025.pdf',
          },
          {
            title: 'Actualización por incremento de nómina 2025',
            url: 'https://forms.gle/QBhBavwvEUYoHQcC7',
          },
          {
            title: 'DECRETO N° 349 MPTeI — 2025',
            url: 'https://produccion.sanjuan.gob.ar/pdf/630COMJE.0021DECRETO0349MPTel-2025.pdf',
          },
          {
            title: 'Resolución 207 - MPTeI - 2025',
            url: 'https://produccion.sanjuan.gob.ar/pdf/RESOLUCION207.pdf',
          },
          {
            title: 'RESOLUCIÓN N° 288-MPTel-2025',
            url: 'https://produccion.sanjuan.gob.ar/pdf/RESOLUCIÓN-288.pdf',
          },
        ],
      },
      {
        target: '_self',
        title: 'Licitaciones',
        url: 'https://licitaciones.sanjuan.gob.ar/',
      },
      {
        target: '_blank',
        title: 'Oferta Exportable',
        url: 'https://ofertaexportable.sanjuan.gob.ar/index_es.php',
      },
      {
        target: '_blank',
        title: 'RIM',
        url: 'https://relevamientoindustrial.sanjuan.gob.ar/',
      },
      {
        target: '_self',
        title: 'Publicaciones',
        links: [
          {
            title: 'Potencial minero de la Provincia de San Juan',
            url: 'https://produccion.sanjuan.gob.ar/pdf/PotencialminerodelaProvinciadeSanJuan.pdf',
          },
          {
            title: 'Infraestructura energética y energías renovables',
            url: 'https://produccion.sanjuan.gob.ar/pdf/Infraestructura_energeticayenergiasrenovables.pdf',
          },
          {
            title: 'Infraestructura logística',
            url: 'https://produccion.sanjuan.gob.ar/pdf/Infraestructura_logistica.pdf',
          },
          {
            title: 'Diversidad productiva de la provincia de San Juan',
            url: 'https://produccion.sanjuan.gob.ar/pdf/DiversidadproductivadelaprovinciadeSanJuan.pdf',
          },
        ],
      },
    ]"
  />

  <NewsComponent titulo="Noticias" />

  <!--   <BoxIconGridComponent titulo="Programas y Financiamiento" :data="[
    {
      desc: null,
      icon: 'ptn-i-produccion',
      target: '_blank',
      title: 'Dirección Instituto Tecnológico y Hortícola Semillero',
      url: 'https://contenido.sanjuan.gob.ar/index.php?n=0&option=com_k2&view=item&id=7008',
    },
    {
      desc: null,
      icon: 'ptn-i-vid',
      target: '_blank',
      title: 'Programa de Compras de Uva por parte del Gobierno de San Juan',
      url: 'https://contenido.sanjuan.gob.ar/index.php?n=0&option=com_k2&view=item&id=5110',
    },
    {
      desc: null,
      icon: 'ptn-i-hacienda-f',
      target: '_blank',
      title: 'Incentivos para el Desarrollo Ganadero',
      url: 'https://contenido.sanjuan.gob.ar/index.php?n=0&option=com_k2&view=item&id=4899',
    },
  ]" /> -->

  <FrecuentAccessComponent
    titulo="Secretarías y Organismos"
    subtitulo="Secretarías"
    :data="[
      {
        color: '#CD2006',
        title: 'Secretaría de Ciencia, Tecnología e Innovación',
        links: [
          {
            target: '_blank',
            title: '(0264) 430 5485',
            url: 'tel:02644305485',
          },
          {
            target: '_blank',
            title: '(0264) 430 5497',
            url: 'tel:02644305497',
          },
          {
            target: '_blank',
            title: 'gvoneuw@sanjuan.gov.ar',
            url: 'mailto:gvoneuw@sanjuan.gov.ar',
          },
          {
            target: '_blank',
            title: 'https://ciencia.sanjuan.gob.ar',
            url: 'https://ciencia.sanjuan.gob.ar',
          },
        ],
      },
      {
        color: '#CD2006',
        title: 'Secretaría de Agricultura, Ganadería y Agroindustria',
        links: [
          {
            target: '_self',
            title: '(0264) 430 5488',
            url: 'tel:2644305488',
          },
          {
            target: '_self',
            title: '(0264) 430 5498',
            url: 'tel:02644305498',
          },
          {
            target: '_self',
            title: 'mlmoreno@sanjuan.gov.ar',
            url: 'mailto:mlmoreno@sanjuan.gov.ar',
          },
        ],
      },
      {
        color: '#CD2006',
        title: 'Secretaría de Coordinación para el Desarrollo Económico',
        links: [
          {
            target: '_self',
            title: '(0264) 430 6420',
            url: 'tel:02644306420',
          },
          {
            target: '_self',
            title: '(0264) 430 6421',
            url: 'tel:02644306421',
          },
          {
            target: '_self',
            title: 'alfaciar@san juan.gov.ar',
            url: 'mailto:alfaciar@san juan.gov.ar',
          },
        ],
      },
      {
        color: '#CD2006',
        title: 'Secretaría de Industria, Comercio y Servicios',
        links: [
          {
            target: '_self',
            title: '(0264) 430 6437',
            url: 'tel:02644306437',
          },
          {
            target: '_self',
            title: '(0264) 430 6438',
            url: 'tel:02644306438',
          },
          {
            target: '_self',
            title: 'alejandro.martin@sanjuan.gov.ar',
            url: 'mailto:alejandro.martin@sanjuan.gov.ar',
          },
        ],
      },
    ]"
  />

  <FrecuentAccessComponent
    subtitulo="Sub-secretarías y Agencias"
    :data="[
      {
        color: '#FF8200',
        title: 'Sub Secretaría de Coordinación Administrativa',
        links: [
          {
            target: '_self',
            title: '(0264) 430 5484',
            url: 'tel:02644305484',
          },
          {
            target: '_self',
            title: 'mmdangelo@sanjuan.gov.ar',
            url: 'mailto:mmdangelo@sanjuan.gov.ar',
          },
        ],
      },
      {
        color: '#1D252D',
        title: 'Fiduciaria San Juan',
        links: [
          {
            target: '_self',
            title: '(0264) 421 1591',
            url: 'tel:02644211591',
          },
          {
            target: '_self',
            title: 'ggelusini@fiduciariasanjuan.com',
            url: 'mailto:ggelusini@fiduciariasanjuan.com',
          },
          {
            target: '_self',
            title: 'https://fiduciariasanjuan.com',
            url: 'https://fiduciariasanjuan.com',
          },
        ],
      },
      {
        color: '#1D252D',
        title: 'Agencia Calidad San Juan',
        links: [
          {
            target: '_self',
            title: '(0264) 427 4391',
            url: 'tel:02644274391',
          },
          {
            target: '_self',
            title: 'mrodriguez@calidadsj.com.ar',
            url: 'mailto:mrodriguez@calidadsj.com.ar',
          },
          {
            target: '_self',
            title: 'https://agenciacalidadsanjuan.com.ar',
            url: 'https://agenciacalidadsanjuan.com.ar',
          },
        ],
      },
      {
        color: '#1D252D',
        title: 'Agencia San Juan Desarrollo de Inversiones',
        links: [
          {
            target: '_self',
            title: '(0264) 429 6282',
            url: 'tel:02644296282',
          },
          {
            target: '_self',
            title: 'mpalisa@inversionessanjuan.gov.ar',
            url: 'mailto:mpalisa@inversionessanjuan.gov.ar',
          },
          {
            target: '_self',
            title: 'https://www.inversionessanjuan.gov.ar/',
            url: 'https://www.inversionessanjuan.gov.ar/',
          },
        ],
      },
    ]"
  />

  <FrecuentAccessComponent
    subtitulo="Dependencia Directa del Ministerio"
    :data="[
      {
        color: '#999999',
        title: 'Relaciones Institucionales y Comunicación',
        links: [
          {
            target: '_self',
            title: '(0264) 430 6435',
            url: 'tel:02644306435',
          },
          {
            target: '_blank',
            title: '(0264) 430 6430',
            url: 'tel:02644306430',
          },
          {
            target: '_self',
            title: 'fmariconda@sanjuan.gov.ar',
            url: 'mailto:fmariconda@sanjuan.gov.ar',
          },
        ],
      },
    ]"
  />

  <AutoriryComponent
    :showProtocolo="false"
    :showLinks="true"
    :data="[
      {
        title: 'Gustavo Emilio Fernandez',
        subtitle: 'Ministro de Producción, Trabajo e Innovación',
        imagen: require('@/assets/img/ministro-produccion.jpg'),
      },
    ]"
  />
</template>

<style>
.multi-slider-mobile {
  display: none;
}

@media (max-width: 993px) {
  .multi-slider {
    display: none;
  }

  .multi-slider-mobile {
    display: block;
  }
}
</style>
